import { useCallback } from "react"
import { useApi } from "./useApi"

export const useOptions = (model, fields, options = { label: null, query: '', link: true }) => {
    const label = options.label || null
    const query = options.query || ''
    const link = options.link || true
    if (!(fields instanceof Array)) fields = [fields]
    const itemToLabel = label || ((item) => fields.map(field => item[field] === null ? '' : item[field] instanceof Date ? item[field].toLocaleDateString() : item[field]).join(' - '))

    const api = useApi()
    return useCallback(async search => await api
        .get(`/${model}?limit=50&${search.length >= 6 ? `or:id:contains=${encodeURIComponent(search)}` : ''}${fields.map(field => `&or:${field}:contains=${encodeURIComponent(search)}`).join('')}&orderBy:asc=${encodeURIComponent(fields[0])}${query ? '&' + query : ''}`)
        .then(data => data.map(item => ({
            value: item.id,
            label: itemToLabel(item),
            item: item,
            link: link ? `/${model}/${item.id}` : null
        })))
        , [model, fields.join(''), query, link])
}